import { render, staticRenderFns } from "./editStaff.page.vue?vue&type=template&id=1be09996&scoped=true&"
import script from "./editStaff.page.vue?vue&type=script&lang=js&"
export * from "./editStaff.page.vue?vue&type=script&lang=js&"
import style0 from "./editStaff.page.vue?vue&type=style&index=0&id=1be09996&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be09996",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1be09996')) {
      api.createRecord('1be09996', component.options)
    } else {
      api.reload('1be09996', component.options)
    }
    module.hot.accept("./editStaff.page.vue?vue&type=template&id=1be09996&scoped=true&", function () {
      api.rerender('1be09996', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rolePage/staff/editStaff.page.vue"
export default component.exports